import { createFileRoute } from "@tanstack/react-router";
import {
  bounceToAccountPath,
  haltForExternalNavigation,
} from "../lib/auth/app-origins";

/** Accept product invite lives on account-web — bounce bookmarks. */
export const Route = createFileRoute("/accept-product-invite")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      bounceToAccountPath("/accept-product-invite", window.location.search);
      haltForExternalNavigation();
    }
  },
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: () => null,
});
